import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {};

const licenseModule = {
  state,
  mutations,
  actions,
  getters,
};

export default licenseModule;
